module.exports = {
  template: require('./owner-registration-requests-form-container.pug')()
  controller: require('./owner-registration-requests-form-container.ctrl')
}
